import util from "../util";
import cityMeshTable from '../table/cityMeshTable';
/**
 * スネーク図の表示
 */
export default class detail_snake {
    //  メッシュコードと市区町村名の対応テーブル
    _cityMeshTable = undefined;
    //  SVG描画エレメント
    //  ※背面と全面のSVGイメージの間に凡例画像が配置される
    _svg_back = document.getElementById('detail_snake_svg_back');
    _svg_front = document.getElementById('detail_snake_svg_front');
    _isImgLink = false;
    _meshcode = '';
    gauge_maxX = 500;
    gauge_maxY = 150;
    namespace = 'http://www.w3.org/2000/svg';
    viewBox_scale = 0.8;
    viewBox_width = 640 * this.viewBox_scale;
    viewBox_height = 480 * this.viewBox_scale;
    gaugeView_width = 570 * this.viewBox_scale;
    gaugeView_height = 450 * this.viewBox_scale;
    gaugeVier_startX = 40 * this.viewBox_scale;
    gaugeView_startY = 4 * this.viewBox_scale;
    //  土壌水指数基準値テーブル
    soilWaterIndexTable = undefined;
    //  土壌水指数基準値テーブルの地点レコード
    soilWaterIndexPointRecord = undefined;
    cpLineMaxY = 0; //cpラインのmaxY座標
    kpLineMaxY = 0; //kpラインのmaxY座標
    /**
     * コンストラクタ
     * @param meshcode メッシュコード
     * @param isImgLink 画像クリック時、ダイアログを表示するか？
     */
    constructor(meshcode, isImgLink) {
        this._isImgLink = isImgLink;
        if (meshcode) {
            this.dispGraph(meshcode);
        }
    }
    /**
     * スネーク図の描画
     * @param uryoPoint
     */
    dispGraph(meshcode) {
        //  初期化
        this.init();
        this._meshcode = meshcode;
        //  画像の表示
        const jsonfile = util.getPath(dosya_1kmesh_env.snake_graph_path);
        const filename = jsonfile.replace("{0}", meshcode);
        //  メッシュコードと市区町村名の対応テーブル
        this._cityMeshTable = new cityMeshTable();
        const city_name = this._cityMeshTable.GetCityName(meshcode);
        $('#city_name').text('市町村名：' + city_name.split('<br>').join('、'));
        let result = false;
        //  JSONファイル読込
        getTextFile(filename, false, (text) => {
            //  データ変換
            const snakeJson = JSON.parse(text);
            //  グラフの描画
            this.createGraph(snakeJson);
            result = true;
            $('section.detail_outof_pref').css('visibility', 'hidden');
            $('section.detail_snake_legends').css('visibility', 'visible');
            $('#detali_snake_cltitleYs').css('visibility', 'visible');
            $('#detali_snake_cltitleXs').css('visibility', 'visible');
            $('.graph-label').css('visibility', 'visible');
        });
        if (!result) {
            $('section.detail_outof_pref').css('visibility', 'visible');
            $('section.detail_snake_legends').css('visibility', 'hidden');
            $('#detali_snake_cltitleYs').css('visibility', 'hidden');
            $('#detali_snake_cltitleXs').css('visibility', 'hidden');
            $('.graph-label').css('visibility', 'hidden');
        }
    }
    /**
     * グラフの描画
     * @param snakeJson
     */
    createGraph(snakeJson) {
        this._svg_back.setAttribute('viewBox', `0 0 ${this.viewBox_width} ${this.viewBox_height}`);
        this._svg_front.setAttribute('viewBox', `0 0 ${this.viewBox_width} ${this.viewBox_height}`);
        this.clear();
        //  背景
        const rect = document.createElementNS(this.namespace, 'rect');
        rect.setAttribute('x', `${this.gaugeVier_startX}`);
        rect.setAttribute('y', `${this.gaugeView_startY}`);
        rect.setAttribute('width', `${this.gaugeView_width}`);
        rect.setAttribute('height', `${this.gaugeView_height}`);
        rect.setAttribute('fill', dosya_1kmesh_env.criticalLineColor.critical);
        this._svg_back.appendChild(rect);
        this.setSoilWaterIndexStandardTable();
        this.setSoilWaterIndexPointRecord();
        const per = this.getPer(snakeJson);
        //  クリティカルエリア（ポリゴン）の描画（除外格子を除く）
        const porigons = this.createCriticalLinePolygon(snakeJson, per);
        this._svg_back.appendChild(porigons.fullPolygon);
        this._svg_back.appendChild(porigons.overCpPolygon);
        this._svg_back.appendChild(porigons.overKpPolygon);
        //  グリッドラインの描画
        this.setGridLine(this._svg_back);
        //  ファイル日時や文言表示
        this.setNote(this._svg_front, snakeJson);
        //  クリティカルラインの描画（除外格子を除く）
        if (!this.isExclusion()) {
            this._svg_back.appendChild(this.createCriticalLine(snakeJson, per));
        }
        //  目盛線の描画
        this.setGauge(this._svg_front);
        //  スネーク図の描画
        this.createSnake(this._svg_front, snakeJson);
        //土壌雨量指数基準(kp,cp)情報出力
        this.drawSoilWaterIndexStandard();
        //凡例を表示
        this.showTheApplicableLegend(per);
        //格子番号を表示
        $('#meshcode').text(this._meshcode);
    }
    /**
     * CriticalLineのポリゴンを生成
     * @param json
     * @param per
     * @returns polygon:CL図ベースポリゴン
     *  overCpPolygon:cpライン超過領域のポリゴン
     *  overKpPolygon:kpライン超過領域のポリゴン
     */
    createCriticalLinePolygon(json, per) {
        const fullPolygon = document.createElementNS(this.namespace, 'polygon');
        const overCpPolygon = document.createElementNS(this.namespace, 'polygon');
        const overKpPolygon = document.createElementNS(this.namespace, 'polygon');
        const cp = this.soilWaterIndexPointRecord.cp;
        const cpPos = this.convert(Number(cp), 0);
        const kp = this.soilWaterIndexPointRecord.kp;
        const kpPos = this.convert(Number(kp), 0);
        const cl = json.head.line;
        const startPoint = this.convert(0, 0);
        let points = `${startPoint.X},${startPoint.Y}`;
        let overCpPoints = `${cpPos.X},${cpPos.Y}`;
        let overCp = true;
        let overKpPoints = `${kpPos.X},${kpPos.Y}`;
        let overKp = true;
        let isWriteEndPoint = false;
        //除外格子の場合はCPラインより左側をfullPolygonで描画、
        //右側をoverCpPolygonで描画する
        if (this.isExclusion()) {
            points += ` ${cpPos.X},${startPoint.Y}`;
            points += ` ${cpPos.X},${this.gaugeView_startY.toString()}`;
            points += ` ${this.gaugeVier_startX.toString()},${this.gaugeView_startY.toString()}`;
            overCpPoints += ` ${(this.gaugeView_width + this.gaugeVier_startX).toString()},${cpPos.Y}`;
            overCpPoints += ` ${(this.gaugeView_width + this.gaugeVier_startX).toString()},${this.gaugeView_startY.toString()}`;
            overCpPoints += ` ${cpPos.X},${this.gaugeView_startY.toString()}`;
        }
        else {
            for (let y = 0; y < cl.length; y++) {
                if (this.isRequiredPoint(cl, y)) {
                    let x = cl[y] * per / 100.0;
                    let clpoint = this.convert(x, y);
                    points += ` ${clpoint.X},${clpoint.Y} `;
                    //cp座標の横軸より大きいか
                    if (overCp && Number(cpPos.X) <= Number(clpoint.X)) {
                        //cpラインを超える部分のx,y座標を追加
                        overCpPoints += ` ${clpoint.X},${clpoint.Y} `;
                        this.cpLineMaxY = y;
                    }
                    else if (overCp) {
                        //cpを超えなくなった時点でcpラインのx座標と最終y座標を追加して終了
                        overCpPoints += ` ${cpPos.X},${clpoint.Y} `;
                        overCp = false;
                    }
                    //kp座標の横軸より大きいか
                    if (overKp && Number(kpPos.X) <= Number(clpoint.X)) {
                        //kpラインを超える部分のx,y座標を追加
                        overKpPoints += ` ${clpoint.X},${clpoint.Y} `;
                        this.kpLineMaxY = y;
                    }
                    else if (overKp) {
                        //kpを超えなくなった時点でkpラインのx座標と最終y座標を追加して終了
                        overKpPoints += ` ${kpPos.X},${clpoint.Y} `;
                        overKp = false;
                    }
                }
                if (this.isWriteEndPoint(cl, y)) {
                    let x = cl[y + 1] * per / 100.0;
                    let clpoint = this.convert(x, y);
                    points += ` ${clpoint.X},${clpoint.Y} `;
                    // clラインが終わるまでにcp、kpラインが終わらない場合各ラインも終了
                    if (overCp) {
                        overCpPoints += ` ${cpPos.X},${clpoint.Y} `;
                        overCp = false;
                    }
                    if (overKp) {
                        overKpPoints += ` ${kpPos.X},${clpoint.Y} `;
                        overKp = false;
                    }
                    isWriteEndPoint = true;
                    //  土壌雨量指数が0になった時点で描画終了とする
                    break;
                }
            }
            // 終点が未決定の場合には追加する(CLラインの座標にX=0が含まれない場合)
            if (!isWriteEndPoint) {
                let x = cl[cl.length - 1] * per / 100.0;
                let clpoint = this.convert(x, cl.length - 1);
                points += ` 0,${clpoint.Y} `;
                if (overCp)
                    overCpPoints += ` ${cpPos.X},${clpoint.Y} `;
                if (overKp)
                    overKpPoints += ` ${kpPos.X},${clpoint.Y} `;
            }
        }
        fullPolygon.setAttribute("points", points);
        overCpPolygon.setAttribute("points", overCpPoints);
        overKpPolygon.setAttribute("points", overKpPoints);
        const safePar = parseInt(json.head.per.replace("%", ""));
        let clColor = "rgba(0,0,0,0)";
        let fillColor = (per > safePar ? dosya_1kmesh_env.criticalLineColor.critical : dosya_1kmesh_env.criticalLineColor.safe);
        let overCpfillColor = (per > safePar ? dosya_1kmesh_env.criticalLineColor.critical : dosya_1kmesh_env.soilWaterIndex.cp.bg_color);
        let overKpfillColor = (per > safePar ? dosya_1kmesh_env.criticalLineColor.critical : dosya_1kmesh_env.soilWaterIndex.kp.bg_color);
        fullPolygon.setAttribute('stroke', clColor);
        fullPolygon.setAttribute('fill', fillColor);
        overCpPolygon.setAttribute('fill', overCpfillColor);
        overKpPolygon.setAttribute('fill', overKpfillColor);
        return { fullPolygon, overCpPolygon, overKpPolygon };
    }
    /**
     * CriticalLineのポリゴンを生成
     * @param json
     * @param per
     */
    createCriticalLine(json, per) {
        const polyline = document.createElementNS(this.namespace, 'polyline');
        const cl = json.head.line;
        let points = "";
        for (let y = 0; y < cl.length; y++) {
            if (this.isRequiredPoint(cl, y)) {
                let x = cl[y] * per / 100.0;
                let clpoint = this.convert(x, y);
                points += ` ${clpoint.X},${clpoint.Y} `;
            }
            if (this.isWriteEndPoint(cl, y)) {
                let x = cl[y + 1] * per / 100.0;
                let clpoint = this.convert(x, y);
                points += ` ${clpoint.X},${clpoint.Y} `;
                //  土壌雨量指数が0になった時点で描画終了とする
                break;
            }
        }
        polyline.setAttribute("points", points);
        //  クリティカルライン
        let clColor = "";
        switch (per) {
            case 100:
                clColor = dosya_1kmesh_env.criticalLineColor.cl_100;
                break;
            case 80:
                clColor = dosya_1kmesh_env.criticalLineColor.cl_80;
                break;
            case 70:
                clColor = dosya_1kmesh_env.criticalLineColor.cl_70;
                break;
        }
        polyline.setAttribute('stroke', clColor);
        const lineWidth = dosya_1kmesh_env.criticalLineColor.width;
        polyline.setAttribute('stroke-width', lineWidth);
        polyline.setAttribute('fill', "none");
        return polyline;
    }
    /**
     * CriticalLine（ポリゴン）描画に必要なポイントか？
     * @param cl
     * @param y
     */
    isRequiredPoint(cl, y) {
        if (y === 0 || y >= cl.length - 1) {
            //  先頭及び終端は必須
            return true;
        }
        if (cl[y - 1] === cl[y] && cl[y] === cl[y + 1]) {
            //  前後の座標値が同一の場合、ポリゴン描画には不用な為、除去
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * 終端ポイントは必要か？
     * @param cl
     * @param y
     */
    isWriteEndPoint(cl, y) {
        if (y >= (cl.length - 1)) {
            return false;
        }
        else if (cl[y + 1] <= 0) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * スネーク図の描画
     * @param svg
     * @param json
     */
    createSnake(svg, json) {
        const sls = json.body;
        //  ラインを先に描画
        if (sls && sls.length > 1) {
            let pre = sls[0];
            for (let i = 1; i < sls.length; i++) {
                let sl = sls[i];
                //  予測値の場合は破線にする
                let isDash = (sl.p === "2");
                this.line(svg, pre.x, pre.y, sl.x, sl.y, dosya_1kmesh_env.snakeLineColor.line, isDash);
                pre = sl;
            }
        }
        let curPoint = null;
        //  ポイントのサークル描画
        for (let i = 0; i < sls.length; i++) {
            let sl = sls[i];
            switch (sl.p) {
                case "0":
                    this.circle(svg, sl.x, sl.y, 4, dosya_1kmesh_env.snakeLineColor.measurement_point);
                    break;
                case "1":
                    curPoint = sl;
                    break;
                case "2":
                    this.circle(svg, sl.x, sl.y, 5, dosya_1kmesh_env.snakeLineColor.predicted_point, true);
                    break;
            }
        }
        //  現在値のサークルは最後に描画する
        //  実況値や予測値が同値の場合でも、わかるように描画する
        if (curPoint) {
            this.circle(svg, curPoint.x, curPoint.y, 5, dosya_1kmesh_env.snakeLineColor.current_point, true);
        }
    }
    /**
     * グリッド線の描画
     * @param svg
     */
    setGridLine(svg) {
        //  X軸
        for (let x = 50; x <= this.gauge_maxX; x += 50) {
            this.line(svg, x, 0, x, this.gauge_maxY, dosya_1kmesh_env.criticalLineColor.grid);
        }
        //  Y軸
        for (let y = 20; y <= this.gauge_maxY; y += 20) {
            this.line(svg, 0, y, this.gauge_maxX, y, dosya_1kmesh_env.criticalLineColor.grid);
        }
    }
    /**
     * データ日時の表示
     * @param svg
     * @param json
     */
    setNote(svg, json) {
        //  日時の表示
        if (json && json.head && json.head.publishTime) {
            let str = json.head.publishTime;
            let year = str.substring(0, 4);
            let month = str.substring(4, 6);
            let day = str.substring(6, 8);
            let hour = str.substring(8, 10);
            let min = str.substring(10, 12);
            let disp = `${year}/${month}/${day} ${hour}:${min}`;
            this.text(svg, 330, 144, disp.toString());
        }
        //  文言表示
        if (this._isImgLink) {
            this.text(svg, 12, 144, dosya_1kmesh_env.label.snake_graph_label1);
            this.text(svg, 12, 137, dosya_1kmesh_env.label.snake_graph_label2);
        }
    }
    /**
     * ゲージの描画
     * @param svg
     */
    setGauge(svg) {
        //  X軸、Y軸
        this.line(svg, 0, 0, this.gauge_maxX, 0);
        this.line(svg, 0, 0, 0, this.gauge_maxY);
        //  X軸目盛
        for (let x = 0; x <= this.gauge_maxX; x += 50) {
            if (x > 0) {
                this.line(svg, x, 0, x, 4);
            }
            this.text(svg, x - 12, -6, x.toString());
        }
        //  Y軸目盛
        let isShort = true;
        for (let y = 10; y <= this.gauge_maxY; y += 10) {
            this.line(svg, 0, y, (isShort ? 5 : 10), y);
            let value = y.toString();
            if (isShort) {
                if (y === this.gauge_maxY) {
                    this.text(svg, -35, y - 4, value);
                }
            }
            else {
                if (y < 100) {
                    this.text(svg, -25, y - 2, value);
                }
                else {
                    this.text(svg, -35, y - 2, value);
                }
            }
            isShort = !isShort;
        }
    }
    /**
     * ラインの描画
     * @param svg
     * @param x1
     * @param y1
     * @param x2
     * @param y2
     * @param color
     * @param isDash
     */
    line(svg, x1, y1, x2, y2, color = "black", isDash = false, width) {
        const element = document.createElementNS(this.namespace, 'line');
        const pos1 = this.convert(x1, y1);
        const pos2 = this.convert(x2, y2);
        element.setAttribute('x1', pos1.X);
        element.setAttribute('y1', pos1.Y);
        element.setAttribute('x2', pos2.X);
        element.setAttribute('y2', pos2.Y);
        element.setAttribute('stroke', color);
        if (isDash) {
            element.setAttribute('stroke-dasharray', "4 4");
        }
        if (width) {
            element.setAttribute('stroke-width', width.toString());
        }
        svg.appendChild(element);
    }
    /**
     * サークルの描画
     * @param svg
     * @param cx
     * @param cy
     * @param r
     * @param color
     */
    circle(svg, cx, cy, cr, color, isStroke = false) {
        const element = document.createElementNS(this.namespace, 'circle');
        const pos = this.convert(cx, cy);
        const r = ((this.gaugeView_width / this.gauge_maxX) * cr).toString();
        element.setAttribute('cx', pos.X);
        element.setAttribute('cy', pos.Y);
        element.setAttribute('r', r);
        if (isStroke) {
            element.setAttribute('stroke', "black");
        }
        element.setAttribute('fill', color);
        svg.appendChild(element);
    }
    /**
     * テキストの描画
     * @param svg
     * @param x
     * @param y
     * @param text
     */
    text(svg, x, y, text) {
        const element = document.createElementNS(this.namespace, 'text');
        const pos = this.convert(x, y);
        element.setAttribute('x', pos.X);
        element.setAttribute('y', pos.Y);
        element.textContent = text;
        svg.appendChild(element);
    }
    /**
     * グラフ座標をSVG上の座標に変換
     * @param x
     * @param y
     */
    convert(x, y) {
        //  座標値が未指定（欠測値）の場合は０として扱う
        if (!x)
            x = 0;
        if (!y)
            y = 0;
        //  ゲージの最大値を超える場合は最大値とする
        if (x >= this.gauge_maxX)
            x = this.gauge_maxX;
        if (y >= this.gauge_maxY)
            y = this.gauge_maxY;
        let dispX = (this.gaugeView_width / this.gauge_maxX) * x + this.gaugeVier_startX;
        let dispY = (this.gaugeView_height / this.gauge_maxY) * (this.gauge_maxY - y) + this.gaugeView_startY;
        return { X: dispX.toString(), Y: dispY.toString() };
    }
    /**
     * SVGのクリア処理
     */
    clear() {
        while (this._svg_back.firstChild) {
            this._svg_back.removeChild(this._svg_back.firstChild);
        }
        while (this._svg_front.firstChild) {
            this._svg_front.removeChild(this._svg_front.firstChild);
        }
    }
    /**
     * 再描画
     */
    reflash() {
        this.dispGraph(this._meshcode);
    }
    getPer(snakeJson) {
        //  per の%を除去、数値に変換
        let per = snakeJson.head.per.replace(/%/g, "");
        return Number(per);
    }
    /**
     * 土壌雨量指数基準(cp,kp)テーブルをプロパティにセットする
     */
    setSoilWaterIndexStandardTable() {
        this.soilWaterIndexTable = getSoilWaterIndexStandardTable();
    }
    /**
     * 土壌雨量指数基準(cp,kp)テーブルの
     * 地点のレコードをプロパティにセットする
     */
    setSoilWaterIndexPointRecord() {
        if (this.soilWaterIndexTable) {
            this.soilWaterIndexPointRecord = this.soilWaterIndexTable[this._meshcode];
        }
    }
    /**
     * 除外格子かのみ取得 false:通常 true:除外格子
     */
    isExclusion() {
        if (this.soilWaterIndexPointRecord)
            return this.soilWaterIndexPointRecord.isExclusion;
        return false;
    }
    /**
     * 土壌雨量指数基準（cp,kp）線の描画
     */
    drawSoilWaterIndexStandard() {
        if (!this.soilWaterIndexPointRecord)
            return;
        if (this.soilWaterIndexPointRecord) {
            //地点のkpとcpを取得
            const cp = Number(this.soilWaterIndexPointRecord.cp);
            const kp = Number(this.soilWaterIndexPointRecord.kp);
            // cp線描画
            this.drawCpLine(cp);
            // kp線描画
            this.drawKpLine(kp);
        }
    }
    /**
     * cpライン描画
     */
    drawCpLine(cp) {
        const color = dosya_1kmesh_env.soilWaterIndex.cp.line_color;
        const lineWidth = dosya_1kmesh_env.soilWaterIndex.cp.line_width;
        //除外格子の場合はグラフ上限の高さまでcpラインを引く
        const maxY = this.isExclusion() ? this.gauge_maxY : this.cpLineMaxY;
        this.line(this._svg_front, cp, 0, cp, maxY, color, false, lineWidth);
    }
    /**
     * kpライン描画
     */
    drawKpLine(kp) {
        const color = dosya_1kmesh_env.soilWaterIndex.kp.line_color;
        const lineWidth = dosya_1kmesh_env.soilWaterIndex.kp.line_width;
        // kp線描画（※除外格子を除く）
        if (!this.isExclusion())
            this.line(this._svg_front, kp, 0, kp, this.kpLineMaxY, color, false, lineWidth);
    }
    /**
     * 該当する凡例を表示する
     */
    showTheApplicableLegend(per) {
        //  状態の凡例表示（※除外格子を除く）
        if (!this.isExclusion()) {
            const criticalLineColors = dosya_1kmesh_env.criticalLineColor;
            const criticalLineLegendTexts = dosya_1kmesh_env.criticalLineLegendText;
            const clIndex = 'cl_' + per.toString();
            const criticalLineColor = criticalLineColors[clIndex];
            const criticalLineLegendText = criticalLineLegendTexts[clIndex];
            $('#state_legend').css('display', 'flex'); //  状態の凡例を横並びで表示する
            $('#state_line_color').css('background-color', criticalLineColor);
            $('#state_legend_text').text(criticalLineLegendText);
            $('#isExclusion_disp').css('display', 'none');
        }
        else {
            //  除外格子では状態の凡例を表示しない
            $('#state_legend').css('display', 'none');
            //  除外格子である旨を表示する
            $('#isExclusion_disp').css('display', 'block');
        }
        //  cpの凡例表示
        const cpColor = dosya_1kmesh_env.soilWaterIndex.cp.line_color;
        const cpText = dosya_1kmesh_env.soilWaterIndex.cp.text;
        $('#cp_legend_text').css('display', 'block');
        $('#cp_line_color').css('display', 'block');
        $('#cp_line_color').css('background-color', cpColor);
        $('#cp_legend_text').text(cpText);
        //  kpの凡例表示（※除外格子を除く）
        if (!this.isExclusion()) {
            const kpColor = dosya_1kmesh_env.soilWaterIndex.kp.line_color;
            const kpText = dosya_1kmesh_env.soilWaterIndex.kp.text;
            $('#kp_info').css('display', 'flex'); //  kpの凡例を横並びで表示する
            $('#kp_line_color').css('background-color', kpColor);
            $('#kp_legend_text').text(kpText);
        }
        else {
            //除外格子ではkp凡例を表示しない
            $('#kp_info').css('display', 'none');
        }
    }
    /**
     * スネーク図初期化
     */
    init() {
        //  画像の初期化
        this.clear();
        // 凡例
        $('#state_legend').css('display', 'none');
        // 除外格子テキスト
        $('#isExclusion_disp').css('display', 'none');
        // cp凡例
        $('#cp_legend_text').css('display', 'none');
        $('#cp_line_color').css('display', 'none');
        // kp凡例
        $('#kp_info').css('display', 'none');
        // 格子番号
        $('#meshcode').text('');
    }
}
